import {
    AdminUsersView,
    AgentFullView,
    AgentsView,
    ApnsView,
    CallListView,
    CampaignListView,
    ChatBotListView,
    ChatScriptListView,
    ConversationListView,
    ConversationView,
    CreateCampaignView,
    DashboardView,
    DataFilesView,
    DatasetsView,
    EmailListView,
    ForgotPassword,
    ImportRecords,
    LinkGroupsView,
    Login,
    MediaGroupsView,
    MessageGroupsView,
    MessagesListView,
    MobileDevicesView,
    ResetPassword,
    RoutesView,
    SessionsView,
    ShortlinksView,
    Signup,
    SimcardFullView,
    SimcardsView,
    SmsTestingView,
    SystemEventsView,
} from './components/views';
import {
    Navigate,
    RouterProvider,
    createBrowserRouter,
} from 'react-router-dom';
import { ProtectedRoute, UnauthenticatedRoute } from './components/common';

import CarriersView from './components/views/resources/carriers/Carriers';
import ChatHandlersView from './components/views/groups/ChatHandlers';
import CreateChatScriptView from './components/views/campaigns/createChatScript/CreateChatScript';

const Routes = () => {
    const router = createBrowserRouter([
        {
            path: '/',
            //element: <Home />,
            element: <UnauthenticatedRoute />,
            children: [{ path: '', element: <Navigate to={'/auth/login'} /> }],
        },
        {
            path: 'auth',
            element: <UnauthenticatedRoute />,
            children: [
                { path: 'login', element: <Login /> },
                { path: 'signup', element: <Signup /> },
                { path: 'forgot', element: <ForgotPassword /> },
                { path: 'reset', element: <ResetPassword /> },
            ],
        },

        {
            path: 'Dashboard',
            element: <ProtectedRoute roles={['DASHBOARD']} />,
            children: [{ path: '', element: <DashboardView /> }],
        },

        {
            path: 'campaigns',
            element: <ProtectedRoute />,
            children: [
                { path: '', element: <CampaignListView /> },
                { path: ':id', element: <CreateCampaignView /> },
                { path: 'messages', element: <MessageGroupsView /> },
                { path: 'media', element: <MediaGroupsView /> },
                { path: 'links', element: <LinkGroupsView /> },
                { path: 'handlers', element: <ChatHandlersView /> },
                { path: 'scripts', element: <ChatScriptListView /> },
                { path: 'scripts/:id', element: <CreateChatScriptView /> },
                { path: 'bots', element: <ChatBotListView /> },
                { path: 'sessions', element: <SessionsView /> },
            ],
        },

        {
            path: 'engagement',
            element: <ProtectedRoute />,
            children: [
                {
                    path: 'sms/conversations',
                    element: <ConversationListView />,
                },
                {
                    path: 'sms/conversations/:id',
                    element: <ConversationView />,
                },
                { path: 'sms/messages', element: <MessagesListView /> },
                { path: 'calls', element: <CallListView /> },
                { path: 'email', element: <EmailListView /> },
            ],
        },

        {
            path: 'data',
            element: <ProtectedRoute />,
            children: [
                { path: '', element: <DatasetsView /> },
                { path: 'sets', element: <DatasetsView /> },
                { path: 'files', element: <DataFilesView /> },
                { path: 'import', element: <ImportRecords /> },
            ],
        },

        {
            path: 'crm',
            element: <ProtectedRoute roles={['CRM']} />,
            children: [],
        },

        {
            path: 'tools',
            element: <ProtectedRoute />,
            children: [{ path: 'sms/test', element: <SmsTestingView /> }],
        },

        {
            path: 'resources',
            element: <ProtectedRoute />,
            children: [
                { path: 'agents', element: <AgentsView /> },
                { path: 'agents/:id', element: <AgentFullView /> },
                { path: 'routes', element: <RoutesView /> },
                { path: 'shortlinks', element: <ShortlinksView /> },
                { path: 'simcards', element: <SimcardsView /> },
                { path: 'simcards/:id', element: <SimcardFullView /> },
                { path: 'devices', element: <MobileDevicesView /> },
                { path: 'carriers', element: <CarriersView /> },
                { path: 'apns', element: <ApnsView /> },
            ],
        },

        {
            path: 'admin',
            element: <ProtectedRoute />,
            children: [
                { path: 'users', element: <AdminUsersView /> },
                { path: 'system/events', element: <SystemEventsView /> },
            ],
        },
    ]);
    return <RouterProvider router={router} />;
};
export default Routes;
